import React from 'react';
import PropTypes from 'prop-types';

import { basePageWrap } from '../BasePage';
import styles from './ArticleListPage.module.scss';

import Hero from '../../components/Hero';
import Wysiwyg from '../../components/Wysiwyg';
import StreamField from '../../components/StreamField';
import Breadcrumbs from '../../components/Breadcrumbs';

const ArticleListPage = ({ hero, richText, contentBlocks, breadcrumbs }) => {
    return (
        <div className={styles['ArticleListPage']}>
            <Breadcrumbs {...breadcrumbs} />
            <Hero {...hero} />
            <div className={styles['ArticleListPage__Container']}>
                {richText && (
                    <Wysiwyg
                        {...richText}
                        modifiers={['Center', 'ArticleListPage']}
                    />
                )}
                {contentBlocks.length > 0 && (
                    <StreamField items={contentBlocks} />
                )}
            </div>
        </div>
    );
};

ArticleListPage.propTypes = {
    hero: PropTypes.object,
    richText: PropTypes.object,
    contentBlocks: PropTypes.array,
    breadcrumbs: PropTypes.object,
};

ArticleListPage.defaultProps = {
    hero: {},
    richText: {},
    breadcrumbs: {},
    contentBlocks: [],
};

export default basePageWrap(ArticleListPage);
